import type {Branded} from '@kapitalist/utils/Branded'
import {brand, unbrand} from '@kapitalist/utils/Branded'

/**
 * A game's monotonic state-version counter (0 = the dealt state), also used as the client's
 * concurrency token. Advances by exactly one per applied action.
 */
export type TGameTime = Branded<number, typeof gameTimeBrand>
export const mkGameTime = (time: number): TGameTime => brand<TGameTime>(time)
declare const gameTimeBrand: unique symbol

export const INITIAL_GAME_TIME = mkGameTime(0)

export const incrementGameTime = (time: TGameTime): TGameTime =>
  mkGameTime(unbrand(time) + 1)
